import React, { memo } from 'react';
import { Button, Form } from 'react-bootstrap';
import { englishToBanglaNumber } from '../../../utils/helpers';

const UnitButtons = ({ unitArray, selectedUnit, fieldName = 'quantityUnit' }) => {
  return (
    <div className="unit-btn">
      {unitArray.map((val, index) => {
        return (
          <Button
            key={index}
            size="sm"
            className={`btn-sm-customize ${val === '' ? 'empty-btn' : ''}`}
            variant="outline-secondary"
            //onClick={() => selectedUnit('select', 'quantityUnit', val)}
            onClick={() => selectedUnit('select', fieldName, val)}
          >
            {val}
          </Button>
        );
      })}
      <Form.Control
        type="text"
        style={{ width: '75px' }}
        size="sm"
        placeholder="যে কোন"
        onChange={(e) =>
          selectedUnit(
            'change',
            fieldName,
            englishToBanglaNumber(e.target.value),
          )
        }
        onBlur={() => selectedUnit('clickOutside')}
      />
    </div>
  );
};
export default memo(UnitButtons);
